import { Card, CardContent, CardHeader, Typography, makeStyles, useTheme } from "@material-ui/core";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDraggable } from 'react-use-draggable-scroll';
import { ServiceCategoryCard } from './ServiceCategoryCard';
import { FeaturedCategoryCard } from './FeaturedCategoryCard';
import { useScrollEdgeHook, calcBorderStyle } from 'util/scrollFade';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    overflowX: "scroll",

    "&>*": {
      marginRight: "0.75rem"
    },
    "&::-webkit-scrollbar": {
      display: "none"
    },
    scrollbarWidth: "none",
    "-ms-overflow-style": "none",
    padding: theme.spacing(1),
    marginTop: theme.spacing(-1),
  }

}));

const ServiceListRows = ({ category, onSelect = (card) => { } }) => {
  const classes = useStyles()
  const ref = useRef()
  const { events } = useDraggable(ref)
  return (
    <Card className={classes.root}>
      <CardHeader title={category?.name} />
      <div className={classes.container}
        {...events}
        ref={ref}
      >
        {category?.services?.map((service, index) => (
          <ServiceCategoryCard key={index} category={service}
            onSelect={(card) => onSelect(card)} />
        ))}
      </div>
    </Card>
  )
}

const ServiceRows = ({
  canAddToCart = true,
  category,
  onSelect = (card) => { }
}) => {
  const classes = useStyles()
  const ref = useRef()
  const containerRef = useRef()
  const { events } = useDraggable(ref)

  const [reachedStart, reachedEnd, { onScroll }, className] = useScrollEdgeHook(ref)

  const theme = useTheme()
  const containerStyle = useMemo(() => {
    return calcBorderStyle(theme.shape.borderRadius, reachedStart, reachedEnd)
  }, [reachedStart, reachedEnd]);


  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      <div
        className={clsx("hints-square", className)}
        style={{
          ...containerStyle,
          transition: 'box-shadow 0.3s',
        }}
      >
        
      </div>

      <Card className={classes.root}>
        <CardHeader title={category?.label} />
        <div className={classes.container}
          {...events}
          ref={ref}
          onScroll={onScroll}
        >
          {category?.bookings
          ?.filter(service => {
            return !service?.fillOptions?.disabled
          })
          ?.map((service, index) => (
            <FeaturedCategoryCard
              canAddToCart={service?.fillOptions?.canAddToCart}
              key={index}
              category={service}
              onSelect={async (card) => await onSelect(card)} />
          ))}
        </div>

      </Card>
    </div>
  )
}

export { ServiceListRows, ServiceRows }